import React, { useState } from "react";
// import CIA from "../assets/images/download (1).png";
import { useNavigate, Link } from "react-router-dom";
import { Menu, X } from "lucide-react"; // For the mobile menu icon

const NextHeader = () => {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  function handleLoginRedirect() {
    navigate("/login");
  }

  return (
    <header className="relative w-full bg-gradient-to-r from-black to-blue-900  z-50">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center opacity-50"
        style={{ backgroundImage: 'url("/path-to-your-background-image.jpg")' }}
      ></div>

      {/* Overlay */}
      <div className="relative flex items-center justify-between px-6 py-4 lg:px-16">
        {/* Logo Section */}
        <div className="flex items-center space-x-4">
          {/* <img src={CIA} alt="CIA Logo" className="w-12 h-12 lg:w-16 lg:h-16" /> */}
          <div>
            <h1 className="text-white text-xl lg:text-3xl font-bold">CRIME</h1>
            <p className="text-white text-sm lg:text-base">
              Law Enforcement
            </p>
          </div>
        </div>

        {/* Desktop Menu */}
        <nav className="hidden md:flex items-center space-x-6">
          <Link to="/" className="text-white hover:text-blue-300">Home</Link>
          <Link to="/contact" className="text-white hover:text-blue-300">Contact</Link>
          <button
            className="bg-white text-black px-4 py-2 rounded-lg hover:bg-gray-300 transition"
            onClick={handleLoginRedirect}
          >
            Log In
          </button>
        </nav>

        {/* Mobile Menu Button */}
        <div className="md:hidden flex items-center">
          <button
            className="bg-white text-black px-4 py-2 rounded-lg hover:bg-gray-300 transition mr-4"
            onClick={handleLoginRedirect}
          >
            Log In
          </button>
          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
            {isMobileMenuOpen ? <X className="text-white w-6 h-6" /> : <Menu className="text-white w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <nav className="md:hidden flex flex-col items-center bg-blue-900 py-4 space-y-4">
          <Link to="/" className="text-white hover:text-blue-300">Home</Link>
          <Link to="/contact" className="text-white hover:text-blue-300">Contact</Link>
        </nav>
      )}
    </header>
  );
};

export default NextHeader;